import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { createNewPricingPlan } from "../../../api/pricing";
import FormComponent from "../../../component/common/FormComponent";
import { message } from "antd";

const NewPricingPlan = ({ setPlans, setAddModal }) => {
  const [loading, setLoading] = useState(false);

  const handleNewPlan = async (values) => {
    setLoading(true);

    try {
      const payload = {
        name: values.name,
        description: values.description,
        price_amount: values.price_amount,
        token: values.token,
        assistant_limit: values.assistant_limit,
        chat_providers: values.chat_providers,
        max_file: values.max_file,
        user_count: values.user_count,
        advance_parameter: values.advance_parameter,
        customize_chat: values.customize_chat,
        currency: "usd",
        interval: "month",
      };

      const res = await createNewPricingPlan(payload);
      const plans = res?.data?.plans;
      if (plans) {
        setPlans(plans);
        message.success(res?.data?.message);
        setAddModal(false);
      };
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };


  const formItems = [
    {
      name: "name",
      label: "Plan Name",
      type: "text",
      rules: [
        {
          required: true,
          message: "Pricing plan name is required!",
        },
      ],
    },
    {
      name: "description",
      label: "Description",
      type: "textArea",
      rows: 3,
      placeholder: "Write about the plan.",
      rules: [
        {
          required: true,
          message: "Pricing plan description is required!",
        },
      ],
    },
    {
      name: "price_amount",
      label: "Price",
      type: "number",
      rules: [
        {
          required: true,
          message: "Plan Price is required!",
        },
      ],
    },
    {
      name: "token",
      label: "Chat Token",
      type: "number",
      rules: [
        {
          required: true,
          message: "Chat token is required!",
        },
      ],
    },
    {
      name: "assistant_limit",
      label: "Assistant Limit",
      type: "number",
      rules: [
        {
          required: true,
          message: "Assistant limit is required!",
        },
      ],
    },
    {
      name: "chat_providers",
      label: "Chat Providers",
      type: "multiselect",
      options: ['openai', 'gemini', 'claude'].map((item) => ({
        label: item,
        value: item,
      })),
      rules: [
        {
          required: true,
          message: "At least one chat provider is required!",
        },
      ],
    },
    {
      name: "max_file",
      label: "Max File Upload",
      type: "number",
      rules: [
        {
          required: true,
          message: "Maximum file upload is required!",
        },
      ],
    },
    {
      name: "user_count",
      label: "User Limit",
      type: "number",
      rules: [
        {
          required: true,
          message: "User limit is required!",
        },
      ],
    },
    {
      name: "advance_parameter",
      label: "Access to Advance Parameter Settings",
      type: "checkbox",
    },
    {
      name: "customize_chat",
      label: "Access to Customize Chat.",
      type: "checkbox",
    },
    {
      name: "submitreset",
      submitlabel: "Create Plan",
      resetlabel: "Reset",
      type: "submitreset",
      className: "m-1",
      loading: loading
    },
  ];


  return (
    <>
      <FormComponent
        formItems={formItems}
        handleSubmit={handleNewPlan}
        layout="vertical"
        className="form"
      />
    </>
  );
};

export default NewPricingPlan;
